import some from "lodash/some"
import findIndex from "lodash/findIndex"
import reduce from "lodash/reduce"
import reverse from "lodash/reverse"
import split from "lodash/split"
import concat from "lodash/concat"
import uniqBy from "lodash/uniqBy"
import isArray from "lodash/isArray"
import get from "lodash/get"
import filter from "lodash/filter"
import isEmpty from "lodash/isEmpty"
import flatMap from "lodash/flatMap"
import forEach from "lodash/forEach"
import {
  RESET_USER_ACCOUNT,
  SET_CUSTOMER_ADDRESS,
  GET_CUSTOMER_SERVICES_FAILED,
  GET_CUSTOMER_SERVICES_FULFILLED,
  GET_CUSTOMER_SERVICES_PENDING,
  CLEAR_CUSTOMER_SERVICES,
  GET_GUEST_BULK_PICKUP_GUIDELINES_PENDING,
  GET_GUEST_BULK_PICKUP_GUIDELINES_FULFILLED,
  GET_GUEST_BULK_PICKUP_GUIDELINES_FAILED,
  GET_GUEST_BULK_WASTE_CLASSIFICATION_PENDING,
  GET_GUEST_BULK_WASTE_CLASSIFICATION_FAILED,
  GET_GUEST_BULK_WASTE_CLASSIFICATION_FULFILLED,
  SET_GUEST_BULK_WASTE_CLASSIFICATION_UNACCEPTED_ITEMS,
  SET_GUEST_BULK_PICKUP_INCLUDED_CATEGORIES,
  GUEST_BULK_PICKUP_CREATE_TICKET_FULFILLED,
  GUEST_BULK_PICKUP_CREATE_TICKET_PENDING,
  GUEST_BULK_PICKUP_CREATE_TICKET_FAILED,
  GUEST_BULK_PICKUP_PRICING_FULFILLED,
  GUEST_BULK_PICKUP_PRICING_PENDING,
  GUEST_BULK_PICKUP_PRICING_FAILED,
  GUEST_BULK_PICKUP_PRICING_RESET,
  GET_GUEST_BULK_PICKUP_DATES_FULFILLED,
  GET_GUEST_BULK_PICKUP_DATES_PENDING,
  GET_GUEST_BULK_PICKUP_DATES_FAILED,
  GET_PICKUP_INFO_PENDING,
  GET_PICKUP_INFO_FAILED,
  GET_PICKUP_INFO_FULFILLED,
  SERVICE_DASHBOARD_PICKUP_INFO_FULFILLED,
  GET_REDESIGNED_DASHBOARD_PICKUP_INFO_PENDING,
  GET_REDESIGNED_DASHBOARD_PICKUP_INFO_FAILED,
  GET_REDESIGNED_DASHBOARD_PICKUP_INFO_FULFILLED,
  GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_PENDING,
  GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_FAILED,
  GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_FULFILLED,
  GET_CONTAINER_NOT_OUT_ELIGIBILITY_FULFILLED,
  GET_CONTAINER_NOT_OUT_ELIGIBILITY_PENDING,
  GET_CONTAINER_NOT_OUT_ELIGIBILITY_FAILED,
  CLEAR_CONTAINER_NOT_OUT_ELIGIBILITY,
  SUBMIT_CONTAINER_NOT_OUT_REQUEST_PENDING,
  SUBMIT_CONTAINER_NOT_OUT_REQUEST_FAILED,
  SUBMIT_CONTAINER_NOT_OUT_REQUEST_FULFILLED,
  CLEAR_SUBMIT_CONTAINER_NOT_OUT_REQUEST,
  GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_PENDING,
  GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_FAILED,
  GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_FULFILLED,
  GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_PENDING,
  GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_FAILED,
  GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_FULFILLED,
  GET_TICKET_PICKUP_INFO_PENDING,
  GET_TICKET_PICKUP_INFO_FAILED,
  GET_TICKET_PICKUP_INFO_FULFILLED,
  GET_ROLLOFF_TICKETS_FAILED,
  CLEAR_TICKET_PICKUP_INFO,
  SET_DASHBOARD_CUSTOMER_ID,
  GET_CUSTOMER_ACCOUNT_PENDING,
  GET_CUSTOMER_ACCOUNT_FULFILLED,
  GET_CUSTOMER_VERIFICATION_FULFILLED,
  GET_CUSTOMER_VERIFICATION_FAILED,
  SET_CUSTOMER_ID,
  SET_CUSTOMER_EMAIL,
  SET_CUSTOMER_PHONE,
  SET_RO_REQUEST_SUCCESS_MESSAGE_SHOWN,
  SET_DASHBOARD_SERVICE_ADDRESS,
  SET_SELECTED_SERVICE_OBJECT,
  GET_TEXT_FOR_CITY_BILLED_BULK_PENDING,
  GET_TEXT_FOR_CITY_BILLED_BULK_FAILED,
  GET_TEXT_FOR_CITY_BILLED_BULK_FULFILLED,
  SET_DASHBOARD_SERVICES,
  SET_LOCATE_SERVICES_METHOD_TYPE,
  SET_MY_SERVICES_MAIN,
  SET_ROLL_OFF_SERVICE_FULFILLED,
  SET_SKIP_VERIFICATION,
  UPDATE_ROLLOFF_SERVICE_REQUEST_FULFILLED,
  RESET_ROLLOFF_TICKET_DETAILS,
  CONFIRM_ROLLOFF_TICKET_CANCEL_FAILED,
  GET_ROLLOFF_TICKET_DETAILS_FAILED,
  SET_ROLL_OFF_SERVICE_FAILED,
  GET_ROLL_OFF_AVAILABLE_DATES_FAILED,
  RESET_MYSERVICES_DASHBOARD,
  CLEAR_GUEST_DATA,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  SET_USER_STATE,
  RESET_SELECTED_ADRRESS_MY_SERVICES,
  SET_LAST_SELECTED_BROKER_ACCOUNT,
  GET_SERVICE_CHANGE_ELIGIBILITY_PENDING,
  GET_SERVICE_CHANGE_ELIGIBILITY_FAILED,
  GET_SERVICE_CHANGE_ELIGIBILITY_FULFILLED,
  SUBMIT_SERVICE_CHANGE_PRICE_PENDING,
  SUBMIT_SERVICE_CHANGE_PRICE_FAILED,
  SUBMIT_SERVICE_CHANGE_PRICE_FULFILLED,
  CLEAR_SERVICE_CHANGE_DATA,
  CLEAR_SERVICE_CHANGE_API_STATUSES,
  GET_SERVICE_CHANGE_HISTORY_PENDING,
  GET_SERVICE_CHANGE_HISTORY_FAILED,
  GET_SERVICE_CHANGE_HISTORY_FULFILLED,
  CANCEL_SERVICE_CHANGE_PENDING,
  CANCEL_SERVICE_CHANGE_FAILED,
  CANCEL_SERVICE_CHANGE_FULFILLED,
  GET_EXTRA_PICKUP_ELIGIBILITY_PENDING,
  GET_EXTRA_PICKUP_ELIGIBILITY_FULFILLED,
  GET_EXTRA_PICKUP_ELIGIBILITY_FAILED,
  GET_EXTRA_PICKUP_DATES_PENDING,
  GET_EXTRA_PICKUP_DATES_FULFILLED,
  GET_EXTRA_PICKUP_DATES_FAILED,
  GET_EXTRA_PICKUP_PRICING_PENDING,
  GET_EXTRA_PICKUP_PRICING_FULFILLED,
  GET_EXTRA_PICKUP_PRICING_FAILED,
  SUBMIT_EXTRA_PICKUP_PENDING,
  SUBMIT_EXTRA_PICKUP_FULFILLED,
  SUBMIT_EXTRA_PICKUP_FAILED,
  SUBMIT_UPDATE_EXTRA_PICKUP_PENDING,
  SUBMIT_UPDATE_EXTRA_PICKUP_FULFILLED,
  SUBMIT_UPDATE_EXTRA_PICKUP_FAILED,
  CLEAR_EXTRA_PICKUP_DATA,
  CLEAR_CANCEL_ORDER_STATUS,
  CANCEL_EXTRA_PICKUP_PENDING,
  CANCEL_EXTRA_PICKUP_FAILED,
  CANCEL_EXTRA_PICKUP_FULFILLED,
  GET_EXTRA_PICKUP_HISTORY_PENDING,
  CANCEL_REPAIR_REQUEST_FAILED,
  CANCEL_REPAIR_REQUEST_PENDING,
  CANCEL_REPAIR_REQUEST_FULFILLED,
  GET_REPAIR_ELIGIBILITY_FAILED,
  GET_REPAIR_ELIGIBILITY_PENDING,
  GET_REPAIR_ELIGIBILITY_FULFILLED,
  GET_EXTRA_PICKUP_HISTORY_FAILED,
  GET_EXTRA_PICKUP_HISTORY_FULFILLED,
  GET_BULK_PICKUP_ELIGIBILITY_PENDING,
  GET_BULK_PICKUP_ELIGIBILITY_FULFILLED,
  GET_BULK_PICKUP_ELIGIBILITY_FAILED,
  GET_BULK_PICKUP_DATES_PENDING,
  GET_BULK_PICKUP_DATES_FULFILLED,
  SET_BULK_PICKUP_ITEMS,
  SET_SMART_CLASSIFIER_BULK_PICKUP_ITEMS,
  GET_BULK_PICKUP_DATES_FAILED,
  GET_BULK_PICKUP_GUIDELINES_PENDING,
  GET_BULK_PICKUP_GUIDELINES_FULFILLED,
  GET_BULK_PICKUP_GUIDELINES_FAILED,
  GET_BULK_WASTE_CLASSIFICATION_PENDING,
  GET_BULK_WASTE_CLASSIFICATION_FAILED,
  GET_BULK_WASTE_CLASSIFICATION_FULFILLED,
  GET_BULK_PICKUP_PRICING_PENDING,
  GET_BULK_PICKUP_PRICING_FULFILLED,
  RESET_BULK_PICKUP_PRICING,
  GET_BULK_PICKUP_PRICING_FAILED,
  SUBMIT_BULK_PICKUP_PENDING,
  SUBMIT_BULK_PICKUP_FULFILLED,
  SUBMIT_BULK_PICKUP_FAILED,
  CLEAR_BULK_PICKUP_DATA,
  CANCEL_BULK_PICKUP_PENDING,
  CANCEL_BULK_PICKUP_FAILED,
  CANCEL_BULK_PICKUP_FULFILLED,
  CANCEL_PAUSE_SERVICE_PENDING,
  CANCEL_PAUSE_SERVICE_FAILED,
  CANCEL_PAUSE_SERVICE_FULFILLED,
  SET_PAUSE_SERVICE_INFO,
  REPORT_MISSED_PICKUP_PENDING,
  REPORT_MISSED_PICKUP_FULFILLED,
  REPORT_MISSED_PICKUP_FAILED,
  SET_REQUEST_MISSED_PICKUP_ORDER_ID,
  SET_REQUEST_MISSED_PICKUP_TRACKING_ID,
  SET_REQUEST_MISSED_PICKUP_CUSTOMER_ID,
  SET_REQUEST_MISSED_PICKUP_SUCCESS,
  SET_REQUEST_MISSED_PICKUP_ERROR,
  SET_GUEST_MISSED_PICKUP_TOKEN,
  CANCEL_MISSED_PICKUP_PENDING,
  CANCEL_MISSED_PICKUP_FAILED,
  CANCEL_MISSED_PICKUP_FULFILLED,
  GET_COMBINED_ORDER_HISTORY_PENDING,
  GET_COMBINED_ORDER_HISTORY_FAILED,
  GET_COMBINED_ORDER_HISTORY_FULFILLED,
  CLEAR_COMBINED_ORDER_HISTORY,
  GET_SERVICE_HISTORY_PENDING,
  GET_SERVICE_HISTORY_FAILED,
  GET_SERVICE_HISTORY_FULFILLED,
  GET_SERVICE_VISUALS_PENDING,
  GET_SERVICE_VISUALS_FAILED,
  GET_SERVICE_VISUALS_FULFILLED,
  CLEAR_SERVICE_VISUALS,
  CLEAR_SERVICES_ORDER_HISTORY,
  SUBMIT_PAUSE_SERVICE_PENDING,
  SUBMIT_PAUSE_SERVICE_FAILED,
  SUBMIT_PAUSE_SERVICE_FULFILLED,
  UPDATE_CURRENT_SERVICE_CHANGE_DATA,
  CLEAR_CURRENT_SERVICE_CHANGE_DATA,
  GET_EXTRA_PICKUP_TICKET_DETAILS_PENDING,
  GET_EXTRA_PICKUP_TICKET_DETAILS_FAILED,
  GET_EXTRA_PICKUP_TICKET_DETAILS_FULFILLED,
  GET_TEXT_FOR_BULK_PENDING,
  GET_TEXT_FOR_BULK_FAILED,
  GET_TEXT_FOR_BULK_FULFILLED,
  GET_TEXT_FOR_ROLLOFF_PENDING,
  GET_TEXT_FOR_ROLLOFF_FAILED,
  GET_TEXT_FOR_ROLLOFF_FULFILLED,
  GET_TEXT_FOR_XPU_PENDING,
  GET_TEXT_FOR_XPU_FAILED,
  GET_TEXT_FOR_XPU_FULFILLED,
  GET_TEXT_FOR_CONTAINER_REPAIR_PENDING,
  GET_TEXT_FOR_CONTAINER_REPAIR_FAILED,
  GET_TEXT_FOR_CONTAINER_REPAIR_FULFILLED,
  GET_TEXT_FOR_VIEW_ETA_PENDING,
  GET_TEXT_FOR_VIEW_ETA_FAILED,
  GET_TEXT_FOR_VIEW_ETA_FULFILLED,
  SET_CONTAINER_REPLACE_REPAIR,
  INCREMENT_BULK_PICKUP_ACTIVE_STEP,
  DECREMENT_BULK_PICKUP_ACTIVE_STEP,
  RESET_BULK_PICKUP_ACTIVE_STEP,
  SET_BULK_CUSTOMER_SELECTED_OPTIONS,
  GET_CITY_BILLED_ELIGIBILITY_URL_PENDING,
  CANCEL_RECYCLING_PICKUP_FULFILLED,
  CANCEL_RECYCLING_PICKUP_PENDING,
  CANCEL_RECYCLING_PICKUP_FAILED,
  SET_CONTAINER_REPAIR_PREVIOUS_PAGE,
  GET_BULK_DISCLAIMER_SERVLET_FULFILLED,
  GET_BULK_DISCLAIMER_SERVLET_PENDING,
  GET_BULK_DISCLAIMER_SERVLET_FAILED,
  SET_GUEST_BULK_PICKUP_ACCORDION_DATA,
} from "constants-lib/actionTypes"
import { userType } from "constants-lib/authentication"
import { localStorageKey } from "constants-lib/localStorage"
import { CHANGE_TYPES } from "constants-lib/increaseDecrease"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const initialState = {
  currentMain: `GettingStarted`,
  pendingMain: ``,
  getCustomerServicesState: ``,
  getPickupInfoState: ``,
  getTicketPickupInfoState: ``,
  locateServicesMethodType: ``,
  locateServicesInputValue: ``,
  pickupInfo: {},
  ticketPickupInfo: {},
  selectedAddress: ``,
  selectedCustomerId: [],
  selectedServiceKey: ``,
  selectedServiceObject: {},
  selectedZipCode: ``,
  services: [],
  uniqueAddressList: [],
  uniqueCustIdAddressObject: {},
  showRollOffRequestSuccessMessage: false,
  verifiedCustomerIDs: [],
  skippedVerificationCustomerServiceIDs: [],
  isDefaultCustomerId: false,
  isDefaultServiceKey: false,
  statusCode: {
    confirmRollOffTicketCancel: ``,
    getCustomerServices: ``,
    getCustomerVerification: ``,
    getPickupInfo: ``,
    getRollOffAvailableDates: ``,
    setRollOffService: ``,
    getRollOffTicketDetails: ``,
    getRollOffTickets: ``,
    getTicketPickupInfo: ``,
  },
  cookiedOrReturningUserHasServices: false,
  cancelRecyclingPickupStatus: "",
  /* service change */
  serviceChangeEligibilityData: {},
  getServiceChangeEligibilityStatus: ``,
  serviceChangeDetails: {},
  submitServiceChangeStatus: ``,
  serviceChangeOrderHistoryData: {},
  getServiceChangeOrderHistoryStatus: ``,
  cancelServiceChangeStatus: ``,
  /* extra pickup */
  extraPickupEligibilityData: {},
  getExtraPickupEligibilityStatus: ``,
  extraPickupDatesData: {},
  getExtraPickupDatesStatus: ``,
  extraPickupPricingData: {},
  submitExtraPickupPricingStatus: ``,
  extraPickupDetails: {},
  submitExtraPickupStatus: ``,
  serviceHistory: [],
  serviceHistoryStatus: ``,
  serviceVisuals: [],
  serviceVisualsStatus: ``,
  getExtraPickupHistoryStatus: ``,
  extraPickupHistoryData: {},
  cancelExtraPickupStatus: ``,
  /* bulk pickup */
  bulkPickupEligibilityData: {},
  getBulkPickupEligibilityStatus: ``,
  bulkPickupDatesData: {},
  bulkPickupItems: {},
  getBulkPickupDatesStatus: ``,
  bulkPickupGuidelinesData: {},
  getBulkPickupGuidelinesStatus: ``,
  bulkPickupPricingData: {},
  getBulkPickupPricingStatus: ``,
  bulkPickupDetails: ``,
  submitBulkPickupStatus: ``,
  guestBulkPickupIncludedCategories: {},
  guestBulkPickupDisclaimerServlet: {},
  guestBulkPickupDisclaimerServletStatus: "",
  guestBulkPickupCreateTicketStatus: ``,
  guestBulkPickupCreateTicket: {},
  guestBulkPickupMobileAccordion: {
    formSection: true,
    WasteClassificationSection: false,
    datesSection: false,
  },
  cancelBulkPickupState: ``,
  guestBulkPickupPricingStatus: ``,
  bulkPickupActiveStep: 0,
  bulkPickupcustomerSelectedOptions: [],
  guestBulkWasteClassificationData: {},
  getBulkWasteClassificationStatus: ``,
  guestBulkWasteClassificationUnacceptedItems: [],

  /* report missed pickup */
  submitMissedPickupRequestDetails: ``,
  submitMissedPickupRequestStatus: ``,
  requestMissedPickupOrderID: ``,
  requestMissedPickupTrackingID: ``,
  requestMissedPickupCustomerID: ``,
  requestMissedPickupSuccess: ``,
  requestMissedPickupError: ``,
  cancelMissedPickupStatus: ``,
  requestGuestMissedPickupToken: ``,
  /* pause service */
  submitPauseServiceStatus: ``,
  pauseServiceDetails: {},
  getCombinedOrderHistoryStatus: ``,
  combinedOrderHistoryData: [],
  currentServiceChangeData: {},
  currentAddWasteData: {},
  cancelPauseServiceState: ``,
  pauseServiceInfo: {},
  /* SMS flows */
  textForBulkStatus: ``,
  textForBulkData: {},
  textForRolloffStatus: ``,
  textForRolloffData: {},
  textForXpuStatus: ``,
  textForXpuData: {},
  textForContainerRepairStatus: ``,
  textForContainerRepairData: {},
  textForViewEtaStatus: ``,
  textForViewEtaData: {},
  /* Redesigned Dashboard */
  redesignedDashboardPickupInfo: {},
  getRedesignedDashboardPickupInfoState: ``,
  redesignedDashboardServiceEligibilityData: {},
  redesignedDashboardServicesDetailsData: {},
  redesignedDashboardServiceEligibilityStatus: ``,
  redesignedDashboardServicesDetailsStatus: ``,
  // Container Not Out
  containerNotOutEligibilityData: {},
  containerNotOutEligibilityStatus: ``,
  containerNotOutSubmissionData: {},
  containerNotOutSubmissionStatus: ``,
  eligibilityApiData: {},
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_USER_ACCOUNT:
      /* filter out empty responses */
      const cookiedOrReturningUserHasServices = !isEmpty(
        filter(state.services, (service) => !isEmpty(service)),
      )

      return {
        ...initialState,
        pickupInfo: state.pickupInfo,
        services: state.services,
        cookiedOrReturningUserHasServices,
        guestBulkPickupIncludedCategories:
          state.guestBulkPickupIncludedCategories,
        guestBulkPickupPricingData: state.guestBulkPickupPricingData,
        guestBulkPickupCreateTicket: state.guestBulkPickupCreateTicket,
        guestBulkPickupCreateTicketStatus:
          state.guestBulkPickupCreateTicketStatus,
        guestBulkPickupGuidelinesData: state.guestBulkPickupGuidelinesData,
        guestBulkPickupDisclaimerServlet:
          state.guestBulkPickupDisclaimerServlet,
        guestBulkPickupDisclaimerServletStatus:
          state.guestBulkPickupDisclaimerServletStatus,
      }

    case SET_CUSTOMER_ADDRESS:
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_CUSTOMER_ID,
        ``,
      )
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_SERVICE_ID,
        ``,
      )

      return {
        ...state,
        getCustomerServicesState: ``,
        getPickupInfoState: ``,
        locateServicesMethodType: ``,
        locateServicesInputValue: action.payload,
        pickupInfo: {},
        redesignedDashboardPickupInfo: {},
        containerNotOutEligibilityData: {},
        containerNotOutSubmissionData: {},
        redesignedDashboardServiceEligibilityData: {},
        redesignedDashboardServicesDetailsData: {},
        selectedAddress: ``,
        selectedCustomerId: [],
        selectedServiceKey: ``,
        selectedServiceObject: {},
        selectedZipCode: ``,
        uniqueAddressList: [],
        uniqueCustIdAddressObject: {},
        showRollOffRequestSuccessMessage: false,
        verifiedCustomerIDs: [],
        skippedVerificationCustomerServiceIDs: [],
        isDefaultCustomerId: false,
        isDefaultServiceKey: false,
        statusCode: {
          confirmRollOffTicketCancel: ``,
          getCustomerServices: ``,
          getCustomerVerification: ``,
          getPickupInfo: ``,
          getRollOffAvailableDates: ``,
          setRollOffService: ``,
          getRollOffTicketDetails: ``,
          getRollOffTickets: ``,
          getTicketPickupInfo: ``,
        },
      }

    case GET_CUSTOMER_ACCOUNT_PENDING: {
      return {
        ...state,
        pickupInfo: {},
        services: [],
      }
    }

    case GET_CUSTOMER_ACCOUNT_FULFILLED: {
      if (action.payload.isCustomerVerified) {
        const customerId = get(
          action.payload,
          `customerAccounts.accounts[0].ezpayId`,
          ``,
        )
        if (customerId !== ``) {
          return {
            ...state,
            verifiedCustomerIDs: [customerId],
          }
        }
      }
      return state
    }

    case GET_CUSTOMER_SERVICES_FAILED:
      return {
        ...state,
        services: [],
        getCustomerServicesState: `failed`,
        statusCode: {
          ...state.statusCode,
          getCustomerServices: action.payload,
        },
      }

    // We need this legacy action handling for the guest users getCustomerServices action
    case GET_CUSTOMER_SERVICES_FULFILLED: {
      const updates = {}
      if (isArray(action.payload.customerServices)) {
        updates.services = action.payload.customerServices
      } else if (action.payload.customerServices.services !== undefined) {
        updates.services = uniqBy(
          concat(state.services, action.payload.customerServices),
          `ezpayId`,
        )
      }
      return {
        ...state,
        ...updates,
        getCustomerServicesState: `fulfilled`,
      }
    }

    case GET_CUSTOMER_SERVICES_PENDING:
      return {
        ...state,
        pickupInfo: {},
        services: [],
        getCustomerServicesState: `pending`,
      }

    case CLEAR_CUSTOMER_SERVICES:
      return {
        ...state,
        getCustomerServicesState: ``,
        services: [],
        selectedServiceObject: {},
      }

    case GET_GUEST_BULK_PICKUP_GUIDELINES_PENDING:
      return {
        ...state,
        getGuestBulkPickupGuidelinesStatus: `pending`,
        guestBulkPickupIncludedCategories: {},
        guestBulkPickupPricingData: {},
        guestBulkPickupMobileAccordion:
          initialState.guestBulkPickupMobileAccordion,
      }

    case GET_GUEST_BULK_PICKUP_GUIDELINES_FULFILLED:
      return {
        ...state,
        guestBulkPickupGuidelinesData: action.payload,
        getGuestBulkPickupGuidelinesStatus: `fulfilled`,
        // clear these items out after the guidelines API is called to prevent stale data
        guestBulkPickupCreateTicketStatus: ``,
        guestBulkPickupCreateTicket: {},
      }
    case SET_GUEST_BULK_PICKUP_ACCORDION_DATA: {
      return {
        ...state,
        guestBulkPickupMobileAccordion: {
          ...initialState.guestBulkPickupMobileAccordion,
          ...action.payload,
        },
      }
    }

    case GET_GUEST_BULK_PICKUP_GUIDELINES_FAILED:
      return {
        ...state,
        getGuestBulkPickupGuidelinesStatus: `failed`,
      }

    case GET_GUEST_BULK_WASTE_CLASSIFICATION_PENDING:
      return {
        ...state,
        guestBulkWasteClassificationData: {},
        getGuestBulkWasteClassificationStatus: `pending`,
      }

    case GET_GUEST_BULK_WASTE_CLASSIFICATION_FULFILLED:
      return {
        ...state,
        guestBulkWasteClassificationData: action.payload,
        getGuestBulkWasteClassificationStatus: `fulfilled`,
      }
    case SET_GUEST_BULK_WASTE_CLASSIFICATION_UNACCEPTED_ITEMS:
      return {
        ...state,
        guestBulkWasteClassificationUnacceptedItems: action.payload,
      }

    case GET_GUEST_BULK_WASTE_CLASSIFICATION_FAILED:
      return {
        ...state,
        guestBulkWasteClassificationData: {},
        getGuestBulkWasteClassificationStatus: `failed`,
      }

    case SET_GUEST_BULK_PICKUP_INCLUDED_CATEGORIES:
      return {
        ...state,
        guestBulkPickupIncludedCategories: action.payload,
      }

    case GUEST_BULK_PICKUP_CREATE_TICKET_FULFILLED:
      return {
        ...state,
        guestBulkPickupCreateTicketStatus: `fulfilled`,
        guestBulkPickupCreateTicket: action.payload,
      }

    case GUEST_BULK_PICKUP_CREATE_TICKET_PENDING:
      return {
        ...state,
        guestBulkPickupCreateTicketStatus: `pending`,
        guestBulkPickupCreateTicket: {},
        statusCode: {
          ...state.statusCode,
        },
      }

    case GUEST_BULK_PICKUP_CREATE_TICKET_FAILED:
      return {
        ...state,
        guestBulkPickupCreateTicketStatus: `failed`,
      }

    case GUEST_BULK_PICKUP_PRICING_FULFILLED:
      return {
        ...state,
        guestBulkPickupPricingData: action.payload,
        guestBulkPickupPricingStatus: `fulfilled`,
      }

    case GUEST_BULK_PICKUP_PRICING_PENDING:
      return {
        ...state,
        guestBulkPickupPricingStatus: `pending`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case GUEST_BULK_PICKUP_PRICING_FAILED:
      return {
        ...state,
        guestBulkPickupPricingStatus: `failed`,
      }

    case GUEST_BULK_PICKUP_PRICING_RESET:
    case GET_CITY_BILLED_ELIGIBILITY_URL_PENDING:
      return {
        ...state,
        guestBulkPickupPricingData: {},
        guestBulkPickupIncludedCategories: {},
        guestBulkPickupPricingStatus: ``,
        guestBulkPickupDates: ``,
        guestBulkPickupInfo: {},
      }

    case GET_GUEST_BULK_PICKUP_DATES_FULFILLED:
      return {
        ...state,
        guestBulkPickupDates: `fulfilled`,
        guestBulkPickupInfo: action.payload.data,
      }

    case GET_GUEST_BULK_PICKUP_DATES_PENDING:
      return {
        ...state,
        guestBulkPickupDates: `pending`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case GET_GUEST_BULK_PICKUP_DATES_FAILED:
      return {
        ...state,
        guestBulkPickupDates: `failed`,
      }

    case GET_PICKUP_INFO_PENDING:
      return {
        ...state,
        getPickupInfoState: `pending`,
      }

    case GET_PICKUP_INFO_FAILED:
      return {
        ...state,
        getPickupInfoState: `failed`,
        statusCode: {
          ...state.statusCode,
          getPickupInfo: action.payload,
        },
      }

    case GET_PICKUP_INFO_FULFILLED:
      return {
        ...state,
        pickupInfo: action.payload.pickupInfo,
        getPickupInfoState: `fulfilled`,
      }

    case SERVICE_DASHBOARD_PICKUP_INFO_FULFILLED:
      return {
        ...state,
        pickupInfo: action.payload,
        getPickupInfoState: `fulfilled`,
      }

    case GET_REDESIGNED_DASHBOARD_PICKUP_INFO_PENDING:
      return {
        ...state,
        getRedesignedDashboardPickupInfoState: `pending`,
      }

    case GET_REDESIGNED_DASHBOARD_PICKUP_INFO_FAILED:
      return {
        ...state,
        getRedesignedDashboardPickupInfoState: `failed`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case GET_REDESIGNED_DASHBOARD_PICKUP_INFO_FULFILLED:
      return {
        ...state,
        redesignedDashboardPickupInfo:
          action.payload.redesignedDashboardPickupInfo,
        getRedesignedDashboardPickupInfoState: `fulfilled`,
      }

    case GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_PENDING:
      return {
        ...state,
        getRedesignedDashboardGuestPickupInfoState: `pending`,
      }

    case GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_FAILED:
      return {
        ...state,
        getRedesignedDashboardGuestPickupInfoState: `failed`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case GET_CONTAINER_NOT_OUT_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        containerNotOutEligibilityData:
          action.payload.containerNotOutEligibility,
        containerNotOutEligibilityStatus: `fulfilled`,
      }

    case GET_CONTAINER_NOT_OUT_ELIGIBILITY_PENDING:
      return {
        ...state,
        containerNotOutEligibilityStatus: `pending`,
      }

    case GET_CONTAINER_NOT_OUT_ELIGIBILITY_FAILED:
      return {
        ...state,
        containerNotOutEligibilityStatus: `failed`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case CLEAR_CONTAINER_NOT_OUT_ELIGIBILITY:
      return {
        ...state,
        containerNotOutEligibilityData: {},
        containerNotOutEligibilityStatus: ``,
      }

    case SUBMIT_CONTAINER_NOT_OUT_REQUEST_PENDING:
      return {
        ...state,
        containerNotOutSubmissionStatus: `pending`,
      }

    case SUBMIT_CONTAINER_NOT_OUT_REQUEST_FAILED:
      return {
        ...state,
        containerNotOutSubmissionStatus: `failed`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case SUBMIT_CONTAINER_NOT_OUT_REQUEST_FULFILLED:
      return {
        ...state,
        containerNotOutSubmissionData:
          action.payload.submitContainerNotOutRequest,
        containerNotOutSubmissionStatus: `fulfilled`,
      }

    case CLEAR_SUBMIT_CONTAINER_NOT_OUT_REQUEST:
      return {
        ...state,
        containerNotOutSubmissionData: {},
        containerNotOutSubmissionStatus: ``,
      }

    case GET_REDESIGNED_DASHBOARD_GUEST_PICKUP_INFO_FULFILLED:
      return {
        ...state,
        redesignedDashboardGuestPickupInfo: action.payload.data,
        getRedesignedDashboardGuestPickupInfoState: `fulfilled`,
      }

    case GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_PENDING:
      return {
        ...state,
        redesignedDashboardServiceEligibilityStatus: `pending`,
      }

    case GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_FAILED:
      return {
        ...state,
        redesignedDashboardServiceEligibilityStatus: `failed`,
        statusCode: {
          ...state.statusCode,
        },
      }

    case GET_REDESIGNED_DASHBOARD_SERVICE_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        redesignedDashboardServiceEligibilityData:
          action.payload.redesignedDashboardServiceEligibilityData,
        eligibilityApiData: get(action.payload, `actualResponse`, {}),
        redesignedDashboardServiceEligibilityStatus: `fulfilled`,
      }

    case GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_PENDING:
      const shouldUpdateRedesignedServicesDetailsPending =
        action.payload.callWithoutUpdate

      const redesignedServicesDetailsPendingUpdates = {
        ...state,
        redesignedDashboardServicesDetailsStatus: `pending`,
      }

      // in the case of legacy broker account flows, we want to call the new services API without updating the getCustomerServicesState redux state, this breaks the flow since broker accounts are still calling the legacy API (same that is used for guest users)
      if (!shouldUpdateRedesignedServicesDetailsPending) {
        redesignedServicesDetailsPendingUpdates.getCustomerServicesState = `pending`
      }

      return redesignedServicesDetailsPendingUpdates

    case GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_FAILED:
      const shouldUpdateRedesignedServicesDetailsFailed =
        action.payload.callWithoutUpdate

      const redesignedServicesDetailsFailedUpdates = {
        ...state,
        redesignedDashboardServicesDetailsStatus: `failed`,
      }

      // in the case of legacy broker account flows, we want to call the new services API without updating the getCustomerServicesState redux state, this breaks the flow since broker accounts are still calling the legacy API (same that is used for guest users)
      if (!shouldUpdateRedesignedServicesDetailsFailed) {
        redesignedServicesDetailsFailedUpdates.getCustomerServicesState = `failed`
        redesignedServicesDetailsFailedUpdates.statusCode = {
          ...state.statusCode,
          getCustomerServices: action.payload.statusCode,
        }
      }

      return redesignedServicesDetailsFailedUpdates

    case GET_REDESIGNED_DASHBOARD_SERVICES_DETAILS_FULFILLED:
      const { redesignedDashboardServicesDetailsData, callWithoutUpdate } =
        action.payload

      // support legacy services API structure for use in the application,
      const legacyData = {
        services: [...state.services],
      }

      const isSingleUpdate = redesignedDashboardServicesDetailsData.length === 1

      // in the case of legacy broker account flows, we want to call the new services API without updating the services redux state, this breaks the flow since broker accounts are still calling the legacy API (same that is used for guest users)
      if (!callWithoutUpdate) {
        // If the redesignedDashboardServicesDetailsData array is only a length of one, this is a single account or specific customerId request, find and update the index in the services state
        if (isSingleUpdate) {
          const selectedService = redesignedDashboardServicesDetailsData[0]
          const indexToUpdate = findIndex(legacyData.services, {
            ezpayId: selectedService.ezpayId,
          })

          if (indexToUpdate > -1) {
            legacyData.services[indexToUpdate] = {
              ...selectedService,
              services: flatMap(selectedService.services),
            }
          } else {
            // else just loop through services array and update in service
            forEach(redesignedDashboardServicesDetailsData, (service) => {
              legacyData.services.push({
                ...service,
                services: flatMap(service.services),
              })
            })
          }
        } else {
          // Else, this was a request for all services on a multi-account, update the entire services object
          legacyData.services = []
          forEach(redesignedDashboardServicesDetailsData, (service) => {
            legacyData.services.push({
              ...service,
              services: flatMap(service.services),
            })
          })
        }
      }

      const updates = {
        ...state,
        ...legacyData,
        // TODO: We're getting services data from two places in this reducer, this should be phased out once we are switched over to the new services API
        redesignedDashboardServicesDetailsData:
          action.payload.redesignedDashboardServicesDetailsData,
        redesignedDashboardServicesDetailsStatus: `fulfilled`,
      }

      // in the case of legacy broker account flows, we want to call the new services API without updating the getCustomerServicesState redux state, this breaks the flow since broker accounts are still calling the legacy API (same that is used for guest users)
      if (!callWithoutUpdate) {
        updates.getCustomerServicesState = `fulfilled`
      }

      return updates

    case GET_TICKET_PICKUP_INFO_PENDING:
      return {
        ...state,
        getTicketPickupInfoState: `pending`,
      }

    case GET_TICKET_PICKUP_INFO_FAILED:
      return {
        ...state,
        getTicketPickupInfoState: `failed`,
        statusCode: {
          ...state.statusCode,
          getTicketPickupInfo: action.payload,
        },
      }

    case GET_TICKET_PICKUP_INFO_FULFILLED:
      return {
        ...state,
        ticketPickupInfo: action.payload,
        getTicketPickupInfoState: `fulfilled`,
      }

    case GET_ROLLOFF_TICKETS_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          getRollOffTickets: action.payload,
        },
      }

    case CLEAR_TICKET_PICKUP_INFO:
      return {
        ...state,
        ticketPickupInfo: {},
        getTicketPickupInfoState: ``,
      }

    case SET_DASHBOARD_CUSTOMER_ID:
      return {
        ...state,
        selectedCustomerId: action.payload,
      }

    case GET_CUSTOMER_VERIFICATION_FULFILLED: {
      const { customerId, isVerified, changeMainAfterVerification } =
        action.payload
      if (isVerified === true) {
        const verifiedCustomerIDs = concat(
          state.verifiedCustomerIDs,
          customerId,
        )
        if (changeMainAfterVerification === true) {
          return {
            ...state,
            currentMain: state.pendingMain,
            pendingMain: initialState.pendingMain,
            verifiedCustomerIDs,
          }
        }
        return {
          ...state,
          verifiedCustomerIDs,
        }
      }
      return state
    }

    case GET_CUSTOMER_VERIFICATION_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          getCustomerVerification: action.payload,
        },
      }

    case SET_CUSTOMER_ID: {
      // const verifiedCustomerIDs = [ action.payload ]
      return {
        ...state,
        // verifiedCustomerIDs,
        locateServicesInputValue: action.payload,
      }
    }

    case SET_CUSTOMER_EMAIL:
      return {
        ...state,
        locateServicesInputValue: action.payload,
      }

    case SET_CUSTOMER_PHONE:
      return {
        ...state,
        locateServicesInputValue: action.payload,
      }

    case SET_RO_REQUEST_SUCCESS_MESSAGE_SHOWN:
      return {
        ...state,
        showRollOffRequestSuccessMessage: false,
      }

    case SET_DASHBOARD_SERVICE_ADDRESS: {
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_CUSTOMER_ID,
        ``,
      )
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_SERVICE_ID,
        ``,
      )

      const updates = {}
      if (action.payload.uniqueAddressList !== undefined) {
        updates.uniqueAddressList = action.payload.uniqueAddressList
      }
      if (action.payload.uniqueCustIdAddressObject !== undefined) {
        updates.uniqueCustIdAddressObject =
          action.payload.uniqueCustIdAddressObject
      }
      if (action.payload.isDefaultCustomerId !== undefined) {
        updates.isDefaultCustomerId = action.payload.isDefaultCustomerId
      } else {
        updates.isDefaultCustomerId = false
      }

      return {
        ...state,
        selectedAddress: action.payload.formattedAddress,
        selectedZipCode: action.payload.zipCode,
        selectedServiceKey:
          action.payload.formattedAddress === state.selectedAddress
            ? state.selectedServiceKey
            : ``,
        getPickupInfoState: ``,
        pickupInfo:
          action.payload.formattedAddress === state.selectedAddress
            ? state.pickupInfo
            : {},
        ...updates,
      }
    }

    case SET_SELECTED_SERVICE_OBJECT:
      return {
        ...state,
        selectedServiceObject: action.payload.selectedServiceObject,
      }

    case GET_TEXT_FOR_CITY_BILLED_BULK_PENDING:
      return {
        ...state,
        textForCityBilledBulkStatus: `pending`,
      }

    case GET_TEXT_FOR_CITY_BILLED_BULK_FAILED:
      return {
        ...state,
        textForCityBilledBulkStatus: `failed`,
      }

    case GET_TEXT_FOR_CITY_BILLED_BULK_FULFILLED:
      return {
        ...state,
        textForCityBilledBulkData: action.payload,
        textForCityBilledBulkStatus: `fulfilled`,
      }

    case SET_DASHBOARD_SERVICES: {
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_CUSTOMER_ID,
        ``,
      )
      ssrWindow.localStorage.setItem(
        localStorageKey.SERVICE_HISTORY_SERVICE_ID,
        ``,
      )

      const customerIdServiceIdArray = split(action.payload.key, ` `)
      const serviceObject = {
        customerId: customerIdServiceIdArray[0],
        serviceId: customerIdServiceIdArray[1],
        lineOfBusiness: customerIdServiceIdArray[2],
      }
      return {
        ...state,
        selectedServiceKey: action.payload.key,
        isDefaultServiceKey: action.payload.isDefaultServiceKey,
        selectedServiceObject: serviceObject,
      }
    }

    case SET_LOCATE_SERVICES_METHOD_TYPE:
      return {
        ...state,
        locateServicesMethodType: action.payload,
      }

    case SET_MY_SERVICES_MAIN: {
      const newMain = action.payload
      if (newMain !== `Dashboard`) {
        const pendingMain =
          state.currentMain === `ROForm` && newMain === `Verification`
            ? `ROForm`
            : ``
        return {
          ...state,
          currentMain: newMain,
          pendingMain,
        }
      }
      return {
        ...state,
        currentMain: newMain,
      }
    }

    case SET_ROLL_OFF_SERVICE_FULFILLED:
      return {
        ...state,
        showRollOffRequestSuccessMessage: true,
      }

    case SET_SKIP_VERIFICATION: {
      const skippedVerificationCustomerServiceIDs = concat(
        state.skippedVerificationCustomerServiceIDs,
        action.payload,
      )
      return {
        ...state,
        skippedVerificationCustomerServiceIDs,
      }
    }

    case UPDATE_ROLLOFF_SERVICE_REQUEST_FULFILLED:
      return {
        ...state,
        showRollOffRequestSuccessMessage: true,
      }

    case RESET_ROLLOFF_TICKET_DETAILS:
      return {
        ...state,
        currentMain: ``,
        skippedVerificationCustomerServiceIDs: [],
        statusCode: {
          confirmRollOffTicketCancel: ``,
          getCustomerServices: ``,
          getCustomerVerification: ``,
          getPickupInfo: ``,
          getRollOffAvailableDates: ``,
          setRollOffService: ``,
          getRollOffTicketDetails: ``,
          getRollOffTickets: ``,
        },
      }

    case CONFIRM_ROLLOFF_TICKET_CANCEL_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          confirmRollOffTicketCancel: action.payload,
        },
      }

    case GET_ROLLOFF_TICKET_DETAILS_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          getRollOffTicketDetails: action.payload,
        },
      }

    case SET_ROLL_OFF_SERVICE_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          setRollOffService: action.payload,
        },
      }

    case GET_ROLL_OFF_AVAILABLE_DATES_FAILED:
      return {
        ...state,
        statusCode: {
          ...state.statusCode,
          getRollOffAvailableDates: action.payload,
        },
      }

    case RESET_MYSERVICES_DASHBOARD:
    case CLEAR_GUEST_DATA:
      return initialState

    case RESET_DASHBOARD_FROM_GETTING_STARTED:
      return {
        ...initialState,
        locateServicesInputValue: state.locateServicesInputValue,
        locateServicesMethodType: `serviceAddress`,
      }

    /* Clear state after logging in. */
    case SET_USER_STATE: {
      if (action.payload === userType.LOGGED_IN) {
        return initialState
      }

      return state
    }

    case RESET_SELECTED_ADRRESS_MY_SERVICES: {
      return {
        ...state,
        selectedAddress: ``,
      }
    }

    case SET_LAST_SELECTED_BROKER_ACCOUNT:
      return {
        ...state,
        selectedZipCode: action.payload.zipCode,
      }

    /* START SERVICE CHANGE ACTIONS */
    case GET_SERVICE_CHANGE_ELIGIBILITY_PENDING:
      return {
        ...state,
        getServiceChangeEligibilityStatus: `pending`,
      }

    case GET_SERVICE_CHANGE_ELIGIBILITY_FAILED:
      const { error } = action.payload
      return {
        ...state,
        getServiceChangeEligibilityStatus: `failed`,
        serviceChangeEligibilityData: error,
      }

    case GET_SERVICE_CHANGE_ELIGIBILITY_FULFILLED:
      const { data, isAddWasteStream, isPauseService } = action.payload

      let newEligibilityData = {
        ...state.serviceChangeEligibilityData,
      }

      if (isAddWasteStream) {
        newEligibilityData.addWasteStream = data
      } else if (isPauseService) {
        newEligibilityData.pauseService = data
      } else {
        newEligibilityData = data
      }

      return {
        ...state,
        getServiceChangeEligibilityStatus: `fulfilled`,
        serviceChangeEligibilityData: newEligibilityData,
      }

    case SUBMIT_SERVICE_CHANGE_PRICE_PENDING:
      return {
        ...state,
        submitServiceChangeStatus: `pending`,
      }

    case SUBMIT_SERVICE_CHANGE_PRICE_FAILED:
      return {
        ...state,
        submitServiceChangeStatus: `failed`,
      }

    case SUBMIT_SERVICE_CHANGE_PRICE_FULFILLED:
      return {
        ...state,
        submitServiceChangeStatus: `fulfilled`,
        serviceChangeDetails: action.payload,
      }

    case CLEAR_SERVICE_CHANGE_DATA:
      return {
        ...state,
        serviceChangeDetails: {},
        submitServiceChangeStatus: ``,
      }

    case CLEAR_SERVICE_CHANGE_API_STATUSES:
      return {
        ...state,
        submitServiceChangeStatus: ``,
      }

    case GET_SERVICE_CHANGE_HISTORY_PENDING:
      return {
        ...state,
        getServiceChangeOrderHistoryStatus: `pending`,
      }

    case GET_SERVICE_CHANGE_HISTORY_FAILED:
      return {
        ...state,
        getServiceChangeOrderHistoryStatus: `failed`,
      }

    case GET_SERVICE_CHANGE_HISTORY_FULFILLED:
      return {
        ...state,
        getServiceChangeOrderHistoryStatus: `fulfilled`,
        serviceChangeOrderHistoryData: action.payload,
      }

    case CANCEL_SERVICE_CHANGE_PENDING:
      return {
        ...state,
        cancelServiceChangeStatus: `pending`,
      }

    case CANCEL_SERVICE_CHANGE_FAILED:
      return {
        ...state,
        cancelServiceChangeStatus: `failed`,
      }

    case CANCEL_SERVICE_CHANGE_FULFILLED:
      return {
        ...state,
        cancelServiceChangeStatus: `fulfilled`,
      }
    /* END SERVICE CHANGE ACTIONS */

    /* EXTRA PICKUP ACTIONS */
    case GET_EXTRA_PICKUP_ELIGIBILITY_PENDING:
      return {
        ...state,
        getExtraPickupEligibilityStatus: `pending`,
        extraPickupEligibilityData: {},
        submitExtraPickupPricingStatus: ``,
        extraPickupPricingData: {},
        getExtraPickupDatesStatus: ``,
        extraPickupDatesData: {},
      }

    case GET_EXTRA_PICKUP_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        extraPickupEligibilityData: action.payload,
        getExtraPickupEligibilityStatus: `fulfilled`,
      }

    case GET_EXTRA_PICKUP_ELIGIBILITY_FAILED:
      return {
        ...state,
        extraPickupEligibilityData: action.payload,
        getExtraPickupEligibilityStatus: `failed`,
      }

    case GET_EXTRA_PICKUP_DATES_PENDING:
      return {
        ...state,
        getExtraPickupDatesStatus: `pending`,
      }

    case GET_EXTRA_PICKUP_DATES_FULFILLED:
      return {
        ...state,
        extraPickupDatesData: action.payload,
        getExtraPickupDatesStatus: `fulfilled`,
      }

    case GET_EXTRA_PICKUP_DATES_FAILED:
      return {
        ...state,
        extraPickupDatesData: action.payload,
        getExtraPickupDatesStatus: `failed`,
      }

    case GET_EXTRA_PICKUP_PRICING_PENDING:
      return {
        ...state,
        submitExtraPickupPricingStatus: `pending`,
      }

    case GET_EXTRA_PICKUP_PRICING_FULFILLED:
      return {
        ...state,
        extraPickupPricingData: action.payload,
        submitExtraPickupPricingStatus: `fulfilled`,
      }

    case GET_EXTRA_PICKUP_PRICING_FAILED:
      return {
        ...state,
        extraPickupPricingData: action.payload,
        submitExtraPickupPricingStatus: `failed`,
      }

    case SUBMIT_EXTRA_PICKUP_PENDING:
      return {
        ...state,
        submitExtraPickupStatus: `pending`,
      }

    case SUBMIT_EXTRA_PICKUP_FULFILLED:
      return {
        ...state,
        extraPickupDetails: action.payload,
        submitExtraPickupStatus: `fulfilled`,
      }

    case SUBMIT_EXTRA_PICKUP_FAILED:
      return {
        ...state,
        extraPickupDetails: action.payload,
        submitExtraPickupStatus: `failed`,
      }

    case SUBMIT_UPDATE_EXTRA_PICKUP_PENDING:
      return {
        ...state,
        submitExtraPickupStatus: `pending`,
      }

    case SUBMIT_UPDATE_EXTRA_PICKUP_FULFILLED:
      return {
        ...state,
        extraPickupDetails: action.payload,
        submitExtraPickupStatus: `fulfilled`,
      }

    case SUBMIT_UPDATE_EXTRA_PICKUP_FAILED:
      return {
        ...state,
        extraPickupDetails: action.payload,
        submitExtraPickupStatus: `failed`,
      }

    case CLEAR_EXTRA_PICKUP_DATA:
      return {
        ...state,
        extraPickupDatesData: {},
        getExtraPickupDatesStatus: ``,
        extraPickupPricingData: {},
        submitExtraPickupPricingStatus: ``,
        extraPickupDetails: {},
        submitExtraPickupStatus: ``,
      }

    case CLEAR_CANCEL_ORDER_STATUS:
      return {
        ...state,
        cancelServiceChangeStatus: ``,
        cancelExtraPickupStatus: ``,
        cancelBulkPickupState: ``,
        cancelPauseServiceState: ``,
        cancelRepairRequestStatus: ``,
        cancelRecyclingPickupStatus: "",
      }

    case CANCEL_EXTRA_PICKUP_PENDING:
      return {
        ...state,
        cancelExtraPickupStatus: `pending`,
      }

    case CANCEL_EXTRA_PICKUP_FAILED:
      return {
        ...state,
        cancelExtraPickupStatus: `failed`,
      }

    case CANCEL_EXTRA_PICKUP_FULFILLED:
      return {
        ...state,
        cancelExtraPickupStatus: `fulfilled`,
      }

    case GET_EXTRA_PICKUP_HISTORY_PENDING:
      return {
        ...state,
        getExtraPickupHistoryStatus: `pending`,
      }

    case CANCEL_REPAIR_REQUEST_FAILED:
      return {
        ...state,
        cancelRepairRequestStatus: `failed`,
      }

    case CANCEL_REPAIR_REQUEST_PENDING:
      return {
        ...state,
        cancelRepairRequestStatus: `pending`,
      }

    case CANCEL_REPAIR_REQUEST_FULFILLED:
      return {
        ...state,
        cancelRepairRequestStatus: `fulfilled`,
      }

    case CANCEL_RECYCLING_PICKUP_FULFILLED:
      return {
        ...state,
        cancelRecyclingPickupStatus: `fulfilled`,
      }
    case CANCEL_RECYCLING_PICKUP_PENDING:
      return {
        ...state,
        cancelRecyclingPickupStatus: `pending`,
      }

    case CANCEL_RECYCLING_PICKUP_FAILED:
      return {
        ...state,
        cancelRecyclingPickupStatus: `failed`,
      }

    case GET_REPAIR_ELIGIBILITY_FAILED:
      return {
        ...state,
        getContainerRepairEligibilityStatus: `failed`,
      }

    case GET_REPAIR_ELIGIBILITY_PENDING:
      return {
        ...state,
        getContainerRepairEligibilityStatus: `pending`,
      }

    case GET_REPAIR_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        getContainerRepairEligibilityStatus: `fulfilled`,
        getContainerRepairEligibility: action.payload,
      }

    case GET_EXTRA_PICKUP_HISTORY_FAILED:
      return {
        ...state,
        getExtraPickupHistoryStatus: `failed`,
      }

    case GET_EXTRA_PICKUP_HISTORY_FULFILLED:
      return {
        ...state,
        getExtraPickupHistoryStatus: `fulfilled`,
        extraPickupHistoryData: action.payload,
      }

    /* BULK PICKUP ACTIONS */
    case GET_BULK_PICKUP_ELIGIBILITY_PENDING:
      return {
        ...state,
        getBulkPickupEligibilityStatus: `pending`,
      }

    case GET_BULK_PICKUP_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        bulkPickupEligibilityData: action.payload,
        getBulkPickupEligibilityStatus: `fulfilled`,
        bulkPickupPricingData: {},
        getBulkPickupPricingStatus: ``,
      }

    case GET_BULK_PICKUP_ELIGIBILITY_FAILED:
      return {
        ...state,
        getBulkPickupEligibilityStatus: `failed`,
      }

    case GET_BULK_PICKUP_DATES_PENDING:
      return {
        ...state,
        getBulkPickupDatesStatus: `pending`,
      }

    case GET_BULK_PICKUP_DATES_FULFILLED:
      return {
        ...state,
        bulkPickupDatesData: action.payload,
        getBulkPickupDatesStatus: `fulfilled`,
      }

    case SET_BULK_PICKUP_ITEMS:
      return {
        ...state,
        bulkPickupItems: {
          ...state.bulkPickupItems,
          ...action.payload,
        },
      }

    case SET_SMART_CLASSIFIER_BULK_PICKUP_ITEMS:
      return {
        ...state,
        bulkPickupItems: action.payload,
      }

    case GET_BULK_PICKUP_DATES_FAILED:
      return {
        ...state,
        getBulkPickupDatesStatus: `failed`,
      }

    case GET_BULK_PICKUP_GUIDELINES_PENDING:
      return {
        ...state,
        getBulkPickupGuidelinesStatus: `pending`,
      }

    case GET_BULK_PICKUP_GUIDELINES_FULFILLED:
      return {
        ...state,
        bulkPickupGuidelinesData: action.payload,
        getBulkPickupGuidelinesStatus: `fulfilled`,
      }

    case GET_BULK_PICKUP_GUIDELINES_FAILED:
      return {
        ...state,
        getBulkPickupGuidelinesStatus: `failed`,
      }

    case GET_BULK_WASTE_CLASSIFICATION_PENDING:
      return {
        ...state,
        getBulkWasteClassificationStatus: `pending`,
      }

    case GET_BULK_WASTE_CLASSIFICATION_FULFILLED:
      return {
        ...state,
        bulkWasteClassificationData: action.payload,
        getBulkWasteClassificationStatus: `fulfilled`,
      }

    case GET_BULK_WASTE_CLASSIFICATION_FAILED:
      return {
        ...state,
        getBulkWasteClassificationStatus: `failed`,
      }

    case GET_BULK_PICKUP_PRICING_PENDING:
      return {
        ...state,
        getBulkPickupPricingStatus: `pending`,
      }

    case GET_BULK_PICKUP_PRICING_FULFILLED:
      return {
        ...state,
        bulkPickupPricingData: action.payload,
        getBulkPickupPricingStatus: `fulfilled`,
      }

    case RESET_BULK_PICKUP_PRICING:
      return {
        ...state,
        bulkPickupPricingData: {},
        getBulkPickupPricingStatus: ``,
      }
    case GET_BULK_PICKUP_PRICING_FAILED:
      return {
        ...state,
        getBulkPickupPricingStatus: `failed`,
      }

    case SUBMIT_BULK_PICKUP_PENDING:
      return {
        ...state,
        submitBulkPickupStatus: `pending`,
      }

    case SUBMIT_BULK_PICKUP_FULFILLED:
      return {
        ...state,
        bulkPickupDetails: action.payload,
        submitBulkPickupStatus: `fulfilled`,
      }

    case SUBMIT_BULK_PICKUP_FAILED:
      return {
        ...state,
        submitBulkPickupStatus: `failed`,
      }

    case CLEAR_BULK_PICKUP_DATA:
      return {
        ...state,
        ...action.payload,
      }

    case CANCEL_BULK_PICKUP_PENDING:
      return {
        ...state,
        cancelBulkPickupState: `pending`,
      }

    case CANCEL_BULK_PICKUP_FAILED:
      return {
        ...state,
        cancelBulkPickupState: `failed`,
      }

    case CANCEL_BULK_PICKUP_FULFILLED:
      return {
        ...state,
        cancelBulkPickupState: `fulfilled`,
      }

    case CANCEL_PAUSE_SERVICE_PENDING:
      return {
        ...state,
        cancelPauseServiceState: `pending`,
      }

    case CANCEL_PAUSE_SERVICE_FAILED:
      return {
        ...state,
        cancelPauseServiceState: `failed`,
      }

    case CANCEL_PAUSE_SERVICE_FULFILLED:
      return {
        ...state,
        cancelPauseServiceState: `fulfilled`,
      }
    /* REPORT MISSED PICKUP */
    case REPORT_MISSED_PICKUP_PENDING:
      return {
        ...state,
        submitMissedPickupRequestStatus: `pending`,
      }
    case REPORT_MISSED_PICKUP_FULFILLED:
      return {
        ...state,
        submitMissedPickupRequestDetails: action.payload,
        submitMissedPickupRequestStatus: `fulfilled`,
      }
    case REPORT_MISSED_PICKUP_FAILED:
      return {
        ...state,
        submitMissedPickupRequestStatus: `failed`,
      }
    case SET_REQUEST_MISSED_PICKUP_ORDER_ID:
      return {
        ...state,
        requestMissedPickupOrderID: action.payload,
      }
    case SET_REQUEST_MISSED_PICKUP_TRACKING_ID:
      return {
        ...state,
        requestMissedPickupTrackingID: action.payload,
      }
    case SET_REQUEST_MISSED_PICKUP_CUSTOMER_ID:
      return {
        ...state,
        requestMissedPickupCustomerID: action.payload,
      }
    case SET_REQUEST_MISSED_PICKUP_SUCCESS:
      return {
        ...state,
        requestMissedPickupSuccess: action.payload,
      }
    case SET_REQUEST_MISSED_PICKUP_ERROR:
      return {
        ...state,
        requestMissedPickupError: action.payload,
      }
    case SET_GUEST_MISSED_PICKUP_TOKEN:
      return {
        ...state,
        requestGuestMissedPickupToken: action.payload,
      }
    case CANCEL_MISSED_PICKUP_PENDING:
      return {
        ...state,
        cancelMissedPickupStatus: `pending`,
      }

    case CANCEL_MISSED_PICKUP_FAILED:
      return {
        ...state,
        cancelMissedPickupStatus: `failed`,
      }

    case CANCEL_MISSED_PICKUP_FULFILLED:
      return {
        ...state,
        cancelMissedPickupStatus: `fulfilled`,
      }
    /* ORDER HISTORY */
    case GET_COMBINED_ORDER_HISTORY_PENDING:
      return {
        ...state,
        getCombinedOrderHistoryStatus: `pending`,
      }

    case GET_COMBINED_ORDER_HISTORY_FAILED:
      return {
        ...state,
        getCombinedOrderHistoryStatus: `failed`,
      }

    case GET_COMBINED_ORDER_HISTORY_FULFILLED:
      return {
        ...state,
        getCombinedOrderHistoryStatus: `fulfilled`,
        extraPickupHistoryData: action.payload,
      }

    case CLEAR_COMBINED_ORDER_HISTORY:
      return {
        ...state,
        getCombinedOrderHistoryStatus: ``,
        combinedOrderHistoryData: [],
      }

    case GET_SERVICE_HISTORY_PENDING:
      return {
        ...state,
        serviceHistoryStatus: `pending`,
      }
    case GET_SERVICE_HISTORY_FAILED:
      return {
        ...state,
        serviceHistory: [],
        serviceHistoryStatus: `failed`,
      }

    case GET_SERVICE_HISTORY_FULFILLED:
      return {
        ...state,
        serviceHistory: reverse(action.payload),
        serviceHistoryStatus: `fulfilled`,
      }

    case GET_SERVICE_VISUALS_PENDING:
      return {
        ...state,
        serviceVisualsStatus: `pending`,
        serviceVisuals: [],
      }

    case GET_SERVICE_VISUALS_FAILED:
      return {
        ...state,
        serviceVisualsStatus: `failed`,
        serviceVisuals: [],
      }

    case GET_SERVICE_VISUALS_FULFILLED:
      return {
        ...state,
        serviceVisualsStatus: `fulfilled`,
        serviceVisuals: reduce(
          action.payload,
          (result, item) => {
            if (
              item.content_type.indexOf("image") !== -1 &&
              result.filter((item) => item.content_type.indexOf("image") !== -1)
                .length < 5
            ) {
              result.push(item)
            }

            if (
              item.content_type.indexOf("video") !== -1 &&
              !some(
                result,
                (item1) => item1.content_type.indexOf("video") !== -1,
              )
            ) {
              result.push(item)
            }

            return result
          },
          [],
        ),
      }

    case CLEAR_SERVICE_VISUALS:
      return {
        ...state,
        serviceVisualsStatus: ``,
        serviceVisuals: [],
      }

    case CLEAR_SERVICES_ORDER_HISTORY:
      return {
        ...state,
        serviceChangeOrderHistoryData: {},
        getServiceChangeOrderHistoryStatus: ``,
        getExtraPickupHistoryStatus: ``,
        extraPickupHistoryData: {},
      }

    case SET_PAUSE_SERVICE_INFO:
      return {
        ...state,
        pauseServiceInfo: action.payload,
      }

    case SUBMIT_PAUSE_SERVICE_PENDING:
      return {
        ...state,
        submitPauseServiceStatus: `pending`,
      }

    case SUBMIT_PAUSE_SERVICE_FAILED:
      return {
        ...state,
        submitPauseServiceStatus: `failed`,
      }

    case SUBMIT_PAUSE_SERVICE_FULFILLED:
      return {
        ...state,
        submitPauseServiceStatus: `fulfilled`,
        pauseServiceDetails: action.payload,
      }

    case UPDATE_CURRENT_SERVICE_CHANGE_DATA:
      if (action.payload.type === CHANGE_TYPES.NEW_SERVICE) {
        return {
          ...state,
          currentAddWasteData: action.payload.data,
        }
      }

      return {
        ...state,
        currentServiceChangeData: action.payload.data,
      }

    case CLEAR_CURRENT_SERVICE_CHANGE_DATA:
      return {
        ...state,
        currentServiceChangeData: {},
        currentAddWasteData: {},
      }

    case GET_EXTRA_PICKUP_TICKET_DETAILS_PENDING:
      return {
        ...state,
        getExtraPickupState: `pending`,
      }

    case GET_EXTRA_PICKUP_TICKET_DETAILS_FAILED:
      return {
        ...state,
        getExtraPickupState: `failed`,
      }

    case GET_EXTRA_PICKUP_TICKET_DETAILS_FULFILLED:
      return {
        ...state,
        extraPickupInfo: action.payload.pickupInfo,
        getExtraPickupState: `fulfilled`,
      }

    case GET_TEXT_FOR_BULK_PENDING:
      return {
        ...state,
        textForBulkStatus: `pending`,
      }

    case GET_TEXT_FOR_BULK_FAILED:
      return {
        ...state,
        textForBulkStatus: `failed`,
      }

    case GET_TEXT_FOR_BULK_FULFILLED:
      return {
        ...state,
        textForBulkData: action.payload,
        textForBulkStatus: `fulfilled`,
      }

    case GET_TEXT_FOR_ROLLOFF_PENDING:
      return {
        ...state,
        textForRolloffStatus: `pending`,
      }

    case GET_TEXT_FOR_ROLLOFF_FAILED:
      return {
        ...state,
        textForRolloffStatus: `failed`,
      }

    case GET_TEXT_FOR_ROLLOFF_FULFILLED:
      return {
        ...state,
        textForRolloffData: action.payload,
        textForRolloffStatus: `fulfilled`,
      }

    case GET_TEXT_FOR_XPU_PENDING:
      return {
        ...state,
        textForXpuStatus: `pending`,
      }

    case GET_TEXT_FOR_XPU_FAILED:
      return {
        ...state,
        textForXpuStatus: `failed`,
      }

    case GET_TEXT_FOR_XPU_FULFILLED:
      return {
        ...state,
        textForXpuData: action.payload,
        textForXpuStatus: `fulfilled`,
      }

    case GET_TEXT_FOR_CONTAINER_REPAIR_PENDING:
      return {
        ...state,
        textForContainerRepairStatus: `pending`,
      }

    case GET_TEXT_FOR_CONTAINER_REPAIR_FAILED:
      return {
        ...state,
        textForContainerRepairStatus: `failed`,
      }

    case GET_TEXT_FOR_CONTAINER_REPAIR_FULFILLED:
      return {
        ...state,
        textForContainerRepairData: action.payload,
        textForContainerRepairStatus: `fulfilled`,
      }

    case GET_TEXT_FOR_VIEW_ETA_PENDING:
      return {
        ...state,
        textForViewEtaStatus: `pending`,
      }

    case GET_TEXT_FOR_VIEW_ETA_FAILED:
      return {
        ...state,
        textForViewEtaStatus: `failed`,
      }

    case GET_TEXT_FOR_VIEW_ETA_FULFILLED:
      return {
        ...state,
        textForViewEtaData: action.payload,
        textForViewEtaStatus: `fulfilled`,
      }
    case SET_CONTAINER_REPLACE_REPAIR:
      return {
        ...state,
        containerReplaceRepair: action.payload,
      }

    case INCREMENT_BULK_PICKUP_ACTIVE_STEP:
      return {
        ...state,
        bulkPickupActiveStep: action.payload,
      }

    case DECREMENT_BULK_PICKUP_ACTIVE_STEP:
      return {
        ...state,
        bulkPickupActiveStep: action.payload,
      }

    case RESET_BULK_PICKUP_ACTIVE_STEP:
      return {
        ...state,
        bulkPickupActiveStep: 0,
      }

    case SET_BULK_CUSTOMER_SELECTED_OPTIONS:
      return {
        ...state,
        bulkPickupcustomerSelectedOptions: action.payload,
      }

    case SET_CONTAINER_REPAIR_PREVIOUS_PAGE:
      return {
        ...state,
        prevContainerRepairPage: action.payload,
      }
    case GET_BULK_DISCLAIMER_SERVLET_PENDING:
      return {
        ...state,
        guestBulkPickupDisclaimerServlet: {},
        guestBulkPickupDisclaimerServletStatus: `pending`,
      }
    case GET_BULK_DISCLAIMER_SERVLET_FULFILLED:
      return {
        ...state,
        guestBulkPickupDisclaimerServlet: action.payload,
        guestBulkPickupDisclaimerServletStatus: `fulfilled`,
      }
    case GET_BULK_DISCLAIMER_SERVLET_FAILED:
      return {
        ...state,
        guestBulkPickupDisclaimerServlet: {},
        guestBulkPickupDisclaimerServletStatus: `failed`,
      }

    default:
      return state
  }
}
